import React, { useState } from 'react';
import { getProductName } from '../../../Utils/ProductUtils';
import { getShowPriceSection } from '../../../Utils/productPageUtils';
import ProductRating from '../../ProductNew/ProductInfoNew/ProductRating';
import ShareProduct from '../../ProductNew/ProductInfoNew/ShareProduct';
import ImageGallaryCarousel from '../ImageGallaryCarousel';
import { SnackBar } from '../PdpHeader/styled';
import DesktopButtons from '../ProductAction/DesktopButtons';
import { ProductNameNew } from '../ProductDetail/styled';
import {
  DeskTopMobile,
  ImageGalleryCover,
  ProductDetailsTopSection,
  StickyDiv,
} from './styled';
import MyloCertNameNew from '../../ProductNew/ProductInfoNew/MyloCertNameNew';
import { FertilityDescriptionNew } from '../../ProductNew/ProductDetail/styled';
import ProductImpacts from '../../ProductNew/ProductInfoNew/ProductImpacts';
import WrapperFeatures from '../../ProductNew/ProductDetail/WrapperFeatures';
import { diaperFeatureData } from '../FertilityTrustSection/constant';

function ImageGalleryWrapper(props) {
  const {
    productData,
    user_review_images,
    userType,
    setAddedToCart,
    showSizePopup,
    isFertilityProduct,
    features,
    fromResult,
    showNewDiaperVariantUx,
    videoRef,
  } = props;
  const [showToast, setShowToast] = useState(false);
  const showNewPriceSection = getShowPriceSection(userType);

  return (
    <>
      <ImageGalleryCover fromResult={fromResult}>
        <StickyDiv>
          <DeskTopMobile desktop>
            <ImageGallaryCarousel
              product={productData}
              user_review_images={user_review_images}
              userType={userType}
              desktop={true}
              isFertilityProduct={isFertilityProduct}
              videoRef={videoRef}
            />
            {showNewPriceSection ? (
              <ShareProduct
                setShowToast={setShowToast}
                productData={productData}
                userType={userType}
                showNewPriceSection={showNewPriceSection}
              />
            ) : null}
          </DeskTopMobile>
          <DeskTopMobile mobile>
            <ImageGallaryCarousel
              product={productData}
              user_review_images={user_review_images}
              userType={userType}
              fromResult={fromResult}
              isFertilityProduct={isFertilityProduct}
              videoRef={videoRef}
              showNewDiaperVariantUx={showNewDiaperVariantUx}
            />
            {showNewPriceSection &&
            !isFertilityProduct &&
            !showNewDiaperVariantUx ? (
              <ShareProduct
                setShowToast={setShowToast}
                productData={productData}
                showNewPriceSection={showNewPriceSection}
              />
            ) : null}
            {(isFertilityProduct || showNewDiaperVariantUx) && (
              <>
                <DeskTopMobile mobile>
                  <MyloCertNameNew
                    productId={productData?.id}
                    certName={productData?.brandName}
                    mobile
                  />
                </DeskTopMobile>
                <ProductDetailsTopSection sectionPadding>
                  <div className="productName">
                    <ProductNameNew>
                      {getProductName(productData)}
                    </ProductNameNew>
                    <ShareProduct
                      setShowToast={setShowToast}
                      productData={productData}
                      showNewPriceSection={false}
                      isFertilityProduct={isFertilityProduct}
                    />
                  </div>
                  <FertilityDescriptionNew
                  // onClick={onClickOfFertilitText}
                  // clickable={userType === "B"}
                  >
                    {showNewDiaperVariantUx
                      ? productData.product_feature
                      : 'Combines the ancient power of Shatavari with expert-backed CoQ10 and L-Methylfolate'}
                  </FertilityDescriptionNew>
                  {productData?.avg_rating > 0 ? (
                    <ProductRating
                      productData={productData}
                      width={'18px'}
                      height={'18px'}
                      fontS={'14px'}
                      showToast={showToast}
                      setShowToast={setShowToast}
                      showNewPriceSection={showNewPriceSection}
                      isFertilityProduct={isFertilityProduct}
                    />
                  ) : null}
                  {isFertilityProduct && <ProductImpacts />}
                  {showNewDiaperVariantUx ? (
                    <WrapperFeatures featureData={diaperFeatureData} />
                  ) : null}
                </ProductDetailsTopSection>
              </>
            )}
          </DeskTopMobile>
          <DesktopButtons
            productData={productData}
            width={'75%'}
            setAddedToCart={setAddedToCart}
            showSizePopup={showSizePopup}
          />
        </StickyDiv>
        <SnackBar className={showToast ? 'show' : ''}>
          Copied to clipboard!
        </SnackBar>
      </ImageGalleryCover>
    </>
  );
}

export default ImageGalleryWrapper;
